import { Component, inject } from '@angular/core';
import { NgForm } from '@angular/forms';
import { AppRoutes } from 'src/app/core/models/routes.model';
import { BaseComponent } from 'src/app/core/components/base-component/base-component.component';
import { EcommerceAuthService } from 'src/app/core/services/ecommerce/ecommerce-auth.service';
import { extractApiErrorDetail } from 'src/app/core/utils/http/api-error.util';

/**
 * Recupero password, passo 1: `POST /auth/password-reset` accoda l'email con il
 * link a `/reset-password?token=...`. Il backend dialoga con Keycloak, quindi
 * la nuova password varrà anche per il login Keycloak.
 */
@Component({
    selector: 'app-forgot-password',
    templateUrl: './forgot-password.component.html',
    styleUrls: ['./forgot-password.component.scss'],
    standalone: false
})
export class ForgotPasswordComponent extends BaseComponent {
  private readonly ecommerceAuthService = inject(EcommerceAuthService);

  readonly AppRoutes = AppRoutes;
  email = '';
  isSubmitting = false;
  submitError: string | null = null;
  /** Testo restituito dal backend dopo l'invio: sostituisce il form. */
  sentMessage: string | null = null;

  async onSubmit(form: NgForm): Promise<void> {
    if (form.invalid || this.isSubmitting) {
      form.control.markAllAsTouched();
      return;
    }

    this.isSubmitting = true;
    this.submitError = null;
    try {
      const response = await this.ecommerceAuthService.requestPasswordReset(this.email.trim());
      this.sentMessage =
        response.detail ||
        'Se l\'indirizzo è registrato riceverai una email con il link per impostare una nuova password.';
    } catch (error) {
      this.submitError = extractApiErrorDetail(
        error,
        'Non è stato possibile inviare la richiesta. Controlla l\'indirizzo e riprova.'
      );
    } finally {
      this.isSubmitting = false;
    }
  }

  /** Permette di ripetere la richiesta (email sbagliata o non ricevuta). */
  reset(): void {
    this.sentMessage = null;
    this.submitError = null;
  }
}
